import { createContext, useContext, useEffect, useState } from 'react';

export const UI_STYLES = [
    { id: 'terminal', label: 'Attuale', description: 'Terminale investigativo, verde neon' },
    { id: 'dossier', label: 'Dossier Editoriale', description: 'Carta, serif, rosso bordeaux' },
    { id: 'evidence', label: 'Evidence Board', description: 'Bacheca del detective, sughero e timbri' },
];
const STYLE_IDS = UI_STYLES.map(s => s.id);

const ThemeContext = createContext({ theme: 'dark', uiStyle: 'terminal', toggleTheme: () => {}, setUiStyle: () => {}, applyPreferences: () => {} });

const STORAGE_KEY = 'app-theme';
const STYLE_KEY = 'app-ui-style';

const readLocal = (key, allowed, fallback) => {
    try {
        const v = localStorage.getItem(key);
        return allowed.includes(v) ? v : fallback;
    } catch { return fallback; }
};

export function ThemeProvider({ children }) {
    const [theme, setTheme] = useState(() => readLocal(STORAGE_KEY, ['light', 'dark'], 'dark'));
    const [uiStyle, setUiStyle] = useState(() => readLocal(STYLE_KEY, STYLE_IDS, 'terminal'));

    useEffect(() => {
        const cl = document.body.classList;
        cl.toggle('light-theme', theme === 'light');
        cl.toggle('dark-theme', theme === 'dark');
        cl.toggle('ui-styled', uiStyle !== 'terminal');
        STYLE_IDS.forEach(id => cl.toggle(`ui-${id}`, uiStyle === id));
        try {
            localStorage.setItem(STORAGE_KEY, theme);
            localStorage.setItem(STYLE_KEY, uiStyle);
        } catch { /* ignore */ }
    }, [theme, uiStyle]);

    const toggleTheme = () => setTheme(t => t === 'dark' ? 'light' : 'dark');

    const applyPreferences = (prefs) => {
        if (!prefs) return;
        if (['light', 'dark'].includes(prefs.mode)) setTheme(prefs.mode);
        if (STYLE_IDS.includes(prefs.style)) setUiStyle(prefs.style);
    };

    return (
        <ThemeContext.Provider value={{ theme, uiStyle, toggleTheme, setUiStyle, applyPreferences }}>
            {children}
        </ThemeContext.Provider>
    );
}

export function useTheme() {
    return useContext(ThemeContext);
}
